import { render } from "./DeliverySettings.vue?vue&type=template&id=da9f7c72"
import script from "./DeliverySettings.vue?vue&type=script&lang=js"
export * from "./DeliverySettings.vue?vue&type=script&lang=js"

import "./DeliverySettings.vue?vue&type=style&index=0&id=da9f7c72&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__